import React from "react";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";

const CustomModal = ({ open, onClose, title, children, actions, anchorRef }) => {
  return (
    <Modal BackdropProps={{
      style: {
        backgroundColor: "transparent"
      }
    }} open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: anchorRef?.current ? anchorRef.current.getBoundingClientRect().bottom + 5 : "50%",
          left: anchorRef?.current
            ? Math.min(anchorRef.current.getBoundingClientRect().left, window.innerWidth - 320)
            : "50%",
          transform: anchorRef?.current ? "none" : "translate(-50%, -50%)",
          width: 300,
          bgcolor: "background.paper",
          boxShadow: 0,
          p: "10px 20px 10px 20px",
          border: "1px solid #EAECF0",
          borderRadius: "10px",
        }}
      >
        <Box>{children}</Box>
      </Box>
    </Modal>
  );
};

export default CustomModal;
